import * as React from 'react';
import { EditorState, convertFromRaw } from 'draft-js';
import RichTextEditorWithScrollbar from './input/RichTextEditorWithScrollbar';

export interface KonkurrenceBeskrivelseProps {
    beskrivelse?: string;
}

function getEditorState(beskrivelse?: string): EditorState {
    if (beskrivelse === undefined || beskrivelse === null) {
        return EditorState.createEmpty();
    }    
    const content = convertFromRaw(JSON.parse(beskrivelse));
    return EditorState.createWithContent(content);
}

export function KonkurrenceBeskrivelse(props: KonkurrenceBeskrivelseProps) {
    return (
        <RichTextEditorWithScrollbar readOnly={true} editorState={getEditorState(props.beskrivelse)} />
    );
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/KonkurrenceBeskrivelse.tsx